import { gql } from '@apollo/client/core'

export const productInfoQuery = gql`
  query productInfo($psi: ID!) {
    printableSku(psi: $psi) {
      id
      skuEditPattern{
        editPattern {
          displayName
        }
      }
      skuColorPattern {
        colorPattern {
          displayName
        }
      }
      sku {
        firstSelectionOption {
          displayName
          thumbnail
        }
        availableSizes {
          name
        }
        product {
          id
          displayName
          brand
          url
        }
      }
    }
  }
`
export const postRequest = gql`
  mutation postNewRequest($input: CreateGroupBuyItemInput!){
    createGroupBuyItem(input : $input){
      errors
      groupBuyItem {
        uuid
      }
    }
  }
`
export const updateRequestInfo = gql`
  mutation updateRequest($input: UpdateGroupBuyItemInput!){
    updateGroupBuyItem(input: $input) {
      errors
      groupBuyItem {
        uuid
      }
    }
  }
`
export const deleteRequestItem = gql`
  mutation deleteRequest($input: DeleteGroupBuyItemInput!){
    deleteGroupBuyItem(input: $input) {
      errors
    }
  }
`
export const deleteRequestSizeInputItem = gql`
  mutation deleteRequestSizeInput($input: DeleteGroupBuyRequestInput!){
    deleteGroupBuyRequest(input: $input) {
      errors
    }
  }
`

export const requestDetailQuery = gql`
  query requestDetail($uuid: String!) {
    groupBuyItem(uuid: $uuid) {
      requesterName
      comment
      expiredDate
      printableSku {
        id
        skuEditPattern {
          editPattern {
            displayName
          }
        }
        skuColorPattern {
          colorPattern {
            displayName
          }
        }
        sku {
          firstSelectionOption {
            displayName
            thumbnail
          }
          availableSizes {
            name
            id
          }
          product {
            id
            displayName
            quantityUnit
            brand
            url
          }
          mappedSizeSpecs {
            size
            part
            from
            to
          }
        }
      }
    }
  }
`
export const submitInput = gql`
  mutation postSizeInputData($input: CreateGroupBuyRequestInput!){
    createGroupBuyRequest(input : $input){
      errors
    }
  }
`
export const requestListQuery = gql`
  query requestList {
    groupBuyItems {
      uuid
      requesterName
      comment
      amount
      expiredDate
      acceptingInput
      isLock
      addedToCart
      sizeItems {
        sizeId
        sizeName
        quantity
      }
      quantity
      printableSku {
        id
        skuEditPattern {
          id
          editPattern {
            displayName
            id
          }
        }
        skuColorPattern {
          id
          colorPattern {
            displayName
            id
            type
          }
        }
        sku {
          firstSelectionOption {
            displayName
            thumbnail
            id
          }
          availableSizes {
            name
            id
          }
          product {
            id
            displayName
            quantityUnit
            brand
            url
            normalProductId
            fastShippingProductId
            plainGoodFastShipping
          }
          skuColorPatterns {
            id
            colorPattern {
              displayName
              type
              image
              id
              lead
            }
          }
        }
      }
      groupBuyRequests{
        uuid
        username
        comment
        sizeItems {
          sizeId
          sizeName
          quantity
        }
        createdAt
      }
      previewFiles
    }
  }
`
export const requestEditInfoQuery = gql`
  query requestEditInfo($uuid: String!) {
    groupBuyItem(uuid: $uuid) {
      requesterName
      comment
      expiredDate
      printableSku {
        id
        skuEditPattern {
          editPattern {
            displayName
          }
        }
        skuColorPattern {
          colorPattern {
            displayName
          }
        }
        sku {
          firstSelectionOption {
            displayName
            thumbnail
          }
          availableSizes {
            name
            id
          }
          product {
            id
            displayName
            quantityUnit
            brand
            url
          }
        }
      }
    }
  }
`

export const updateSizeInputRecord = gql`
  mutation updateRequestSizeInput($input: UpdateGroupBuyRequestInput!) {
    updateGroupBuyRequest(input: $input) {
      errors
    }
  }
`

export const groupBuyItemInputListQuery = gql`
  query groupBuyItemInputList($uuid: String!) {
    groupBuyItem(uuid: $uuid) {
      groupBuyRequests{
        uuid
        username
        comment
        sizeItems {
          sizeId
          sizeName
          quantity
        }
        createdAt
      }
      sizeItems {
        sizeId
        quantity
      }
      amount
      quantity
    }
  }
`
export const lockGroupBuyItem = gql`
  mutation lockGroupBuyItem($input: LockGroupBuyItemInput!) {
    lockGroupBuyItem(input: $input) {
      errors
      groupBuyItem {
        uuid
        isLock
      }
    }
  }
`

export const createCartFromRequest = gql`
  mutation createCartItemFromGroupBuyItem($input: CreateFromGroupBuyItemInput!) {
    createFromGroupBuyItem(input: $input) {
      cartItem {
        id
      }
      errors
    }
  }
`
export const printableSkuQuery = gql`
  query printableSku(
    $id: ID!,
    $firstOptionId: ID!,
    $skuEditPatternId: ID!,
    $skuColorPatternId: ID!
  ) {
    productByPrintableSku(
      id: $id,
      firstOptionId: $firstOptionId,
      skuColorPatternId: $skuColorPatternId,
      skuEditPatternId: $skuEditPatternId
    ) {
      printableSkuId
      estimate {
        selectedEditPattern {
          id
          editPattern {
            id
          }
        }
      }
      sku {
        skuEditPatterns {
          id
          editPattern {
            displayName
            lead
            image
            id
          }
        }
      }
    }
  }
`
